import { pathToAssignmentThumbnail } from "./route-helpers";
export function getThumbnailPath(kind, courseId, thumbnailName) {
    if (!thumbnailName || thumbnailName.length === 0) {
        return undefined;
    }
    return pathToAssignmentThumbnail(kind, courseId) + "/" + thumbnailName;
}
